"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHoleScored = isHoleScored;
exports.countCompletedHoles = countCompletedHoles;
exports.getRoundScoreForRound = getRoundScoreForRound;
exports.holesCompletedForScoreCode = holesCompletedForScoreCode;
exports.maxCompletedHolesFromEventScores = maxCompletedHolesFromEventScores;
/** True when a hole has a non-zero player (and optionally marker) score entered. */
function isHoleScored(hole, options) {
    if (!hole)
        return false;
    const playerScored = hole.playerScore != null && hole.playerScore !== 0 && Number(hole.playerScore) !== 0;
    if (playerScored)
        return true;
    if (options?.includeMarker) {
        return hole.markerScore != null && hole.markerScore !== 0 && Number(hole.markerScore) !== 0;
    }
    return false;
}
/** Count holes with a score entered on the scorecard. */
function countCompletedHoles(holeScores, options) {
    if (!Array.isArray(holeScores) || holeScores.length === 0)
        return 0;
    return holeScores.filter((hole) => isHoleScored(hole, options)).length;
}
/** Resolve roundScores[n] for a 1-based round number. */
function getRoundScoreForRound(score, roundNumber) {
    if (!Array.isArray(score?.roundScores))
        return null;
    return (score.roundScores.find((r) => Number(r?.roundNumber) === roundNumber)
        ?? score.roundScores[roundNumber - 1]
        ?? null);
}
/** Holes completed for the EventScore whose playerScoreCode matches scoreCode (playerScore only). */
function holesCompletedForScoreCode(scores, scoreCode, roundNumber) {
    const row = scores.find((s) => s.playerScoreCode === scoreCode);
    if (!row)
        return 0;
    const rs = getRoundScoreForRound(row, roundNumber);
    return countCompletedHoles(rs?.holeScores);
}
/** Max holes completed across one or more event score rows for a round. */
function maxCompletedHolesFromEventScores(scores, roundNumber, options) {
    let max = 0;
    for (const score of scores) {
        const rs = getRoundScoreForRound(score, roundNumber);
        const count = countCompletedHoles(rs?.holeScores, options);
        if (count > max)
            max = count;
    }
    return max;
}
